module.exports = __webpack_public_path__ + "static/selune-symbol-SCAG-17b334617a63387340cbaca62af8fcde.png";